<template>
    <page>
        <module>
            <div class="guide-detail">
                <!-- 标题 -->
                <h1 class="guide-title">{{ name }}</h1>
                <!-- 发布时间> -->
                <p class="guide-time">发布时间：{{ create_date }}</p>
                <!-- 横向分割线 -->
                <div class="guide-line"></div>
                <!-- 视频区域（如果有视频） -->
                <div v-if="video_url" class="video-section">
                    <video controls preload="metadata" style="width: 100%; max-width: 800px; height: auto;">
                        <source :src="video_url" type="video/mp4">
                        您的浏览器不支持视频播放。
                    </video>
                </div>
                <!-- 文章内容 -->
                <div class="guide-content" v-html="content"></div>
            </div>
        </module>
    </page>
</template>

<script>
export default {
    name: 'hellp_detail',

    props: {
        id: String
    },

    data() {
        return {
            name: '',//标题
            img_url: '',//封面图
            video_url: '',//视频
            content: '',// 内容
            create_date: ''
        }
    },

    computed: {

    },

    watch: {
        id() {
            this.getDetail();
        },
    },

    mounted() {
        if (this.id) {
            this.getDetail();
        }
    },

    methods: {
        getDetail() {
            this.request({
                url: '/abstract_consultation/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.name=data.name;
                    this.img_url=data.img_url;
                    this.video_url=data.video_url;
                    this.content=data.content;
                    this.create_date=data.create_date;
                }
            });
        }
    }
}
</script>

<style scoped>
.guide-detail {
    padding: 20px;
    width: 1000px;
    margin: 0 auto;
}

.guide-title {
    text-align: center;
    margin-bottom: 30px;
    color: #333;
    font-size: 28px;
    font-weight: bold;
}
.guide-time {
    text-align: left;
    margin-bottom: 10px;
    color: #999;
    font-size: 14px;
}
.guide-line {
    width: 100%;
    height: 1px;
    background-color: #ddd;
    margin-bottom: 30px;
}

.video-section {
    margin-bottom: 30px;
    text-align: center;
}

.guide-content {
    line-height: 1.9;
    color: #555;
    font-size: 16px;
    padding: 15px;
    word-break: break-word;
    word-wrap: break-word;
    text-indent: 2em;
}


</style>
